import * as Dialog from "@radix-ui/react-dialog";
import { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row, Tab, Tabs } from "react-bootstrap";
import TextInput from "../../../common/TextInput";
import moment from "moment";
import DateRangePicker from "../../../common/CustomDateRangePicker";
import {
  fetchCaseStakeholderList,
  fetchPickListByGroupName,
} from "../../../services/CaseInformationApi";
import {
  PICKLIST_GROUP_NAME,
  STAKEHOLDER_LIST_CODE,
} from "../../../common/Constant";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import SearchableMultiSelectDropdown from "../../../common/SearchableMultiSelectDropdown";
import TimePicker from "../../../common/TimePicker";
import {
  AddedQMEDoctorHospitalList,
  AddedQMEDoctorList,
} from "../../../services/ScheduleAppointmentApi";
import FloatingLabelDatepicker from "../../../common/DatePicker";
import { fetchDocumentCategory } from "../../../services/UploadRecordsApi";
import { formatDateTime } from "../../../utils/dateUtils";

interface TabItem {
  label: string;
}

const TABS: TabItem[] = [
  { label: "Case info" },
  { label: "Parties" },
  { label: "Patient" },
  { label: "QME Schedule" },
  { label: "Records" },
];

interface AdvancedSearchPopupProps {
  isOpen: boolean;
  onClose: () => void;
  selectedTab: string;
  onSearch: (filters: any) => void;
  initialFilters?: any;
  onReset: () => void;
}
const AppointmentAdvanceSearch: React.FC<AdvancedSearchPopupProps> = ({
  isOpen,
  onClose,
  selectedTab = "Case info",
  onSearch,
  initialFilters,
  onReset,
}) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);

  const startOfMonth = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    1,
  );

  const today = new Date();
  const oneYearAgo = new Date(
    today.getFullYear() - 1,
    today.getMonth(),
    today.getDate(),
  );

  const todayDate = moment().format("YYYY-MM-DD");
  const firstDayOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const [dateRange, setDateRange] = useState<
    [Date | undefined, Date | undefined]
  >([startOfMonth, today]);

  const [activeTab, setActiveTab] = useState(selectedTab);
  const [caseId, setCaseId] = useState("");

  const [incidentdateRange, setincidentdateRange] = useState<
    [Date | null, Date | null]
  >([null, null]);
  const [dateOfRegistrationFrom, setRegistrationStartDate] = useState<
    string | null
  >(firstDayOfMonth);
  const [dateOfRegistrationTo, setRegistrationEndDate] = useState<
    string | null
  >(todayDate);

  const [selectedPriority, setSelectedPriority] = useState<(string | number)[]>(
    [],
  );
  const [selectedCaseReview, setSelectedCaseReview] = useState<
    (string | number)[]
  >([]);
  const [claimNumber, setClaimNo] = useState("");
  const [wcabNumber, setWcabNo] = useState("");
  const [panelNumber, setPanelNo] = useState("");
  const [fileNumber, setFileNo] = useState("");
  const [caseName, setCaseName] = useState("");
  const [caseNumber, setCaseNumber] = useState("");
  const [adjNumber, setAdjNo] = useState("");
  const [selectedCaseStage, setSelectedCaseStage] = useState<
    (string | number)[]
  >([]);

  //--- Party Tab
  const [selectedClient, setselectedClient] = useState<(string | number)[]>([]);
  const [selectedApplicantAttrorney, setSelectedApplicantAttrorney] = useState<
    (string | number)[]
  >([]);
  const [selectedDefenceAttorney, setSelectedDefenceAttorney] = useState<
    (string | number)[]
  >([]);
  const [selectedInsurance, setSelectedInsurance] = useState<
    (string | number)[]
  >([]);

  //-- patient tab
  const [subjectName, setName] = useState("");
  const [ssn, setSsnNo] = useState("");
  const [isSSNFocused, setIsSSNFocused] = useState(false);
  const [selectedInjuryType, setSelectedInjuryType] = useState<
    (string | number)[]
  >([]);
  const [selectedSeverityOfInjury, setSelectedSeverityOfInjury] = useState<
    (string | number)[]
  >([]);
  const [selectedEmployer, setselectedEmployer] = useState<(string | number)[]>(
    [],
  );
  const [dateOfIncidentFrom, setIncidentStartDate] = useState<string | null>(
    null,
  );
  const [dateOfIncidentTo, setIncidentEndDate] = useState<string | null>(null);

  //---QME Tab
  const [appointmentConfirmationNo, setAppointmentNumber] = useState("");
  const [appintmentdateRange, setAppointmentdateRange] = useState<
    [Date | null, Date | null]
  >([null, null]);
  const [dateOfAppointmentStart, setAppointmentStartDate] = useState<
    string | null
  >(null);
  const [dateOfAppointmentEnd, setAppointmentEndDate] = useState<string | null>(
    null,
  );
  const [startTime, setAppointmentStartTime] = useState<any>("");
  const [StartdateOfAppointment, setStartDateOfAppointment] = useState<Date>(
    new Date(),
  );
  const [selectedAppointmentStatus, setSelectedAppointmentStatus] = useState<
    (string | number)[]
  >([]);
  const [selectedClinic, setSelectedClinic] = useState<(string | number)[]>([]);
  const [selectedQME, setSelectedQME] = useState<(string | number)[]>([]);
  const [selectedQMECategory, setSelectedQMECategory] = useState<
    (string | number)[]
  >([]);
  const [selectedQMEType, setSelectedQMEType] = useState<(string | number)[]>(
    [],
  );
  const [isInterpreterReq, setIsInterpreterReq] = useState<
    boolean | undefined
  >();
  const [medicalExamOptions, setMedicalExamOptions] = useState<
    { value: string; label: string }[]
  >([]);

  const [ismedicalExam, setIsMedicalExam] = useState<string | null>(null);

  //--Record Tab

  const [selectedDocumentTypeIds, setSelectedDocumentTypeIds] = useState<
    (string | number)[]
  >([]);

  const [selectedDocumentCategoryIds, setSelectedDocumentCategoryIds] =
    useState<(string | number)[]>([]);
  const [uploadDateTime, setUploadDateTime] = useState<Date | null>(null);

  const [fileName, setFileName] = useState("");
  const [addlFileDesc, setAddlFileDesc] = useState("");
  const [uploadedByName, setUploadedByName] = useState("");
  const [additionalComments, setAdditionalComments] = useState("");

  //dropdown options
  const [priorityOptions, setPriorityOptions] = useState<any[]>([]);
  const [caseReviewOptions, setCaseReviewOptions] = useState<any[]>([]);
  const [caseStageOptions, setCaseStageOptions] = useState<any[]>([]);

  //party Tab
  const [employerOptions, setemployerOptions] = useState<any[]>([]);

  const [clientOptions, setclientOptions] = useState<any[]>([]);
  const [applicantAttorneyOptions, setapplicantAttorneyOptions] = useState<
    any[]
  >([]);
  const [defenceAttorneyOptions, setdefenceAttorneyOptions] = useState<any[]>(
    [],
  );
  const [insuranceOptions, setinsuranceOptions] = useState<any[]>([]);

  //patient tab
  const [injuryTypeOptions, setInjuryTypeOptions] = useState<any[]>([]);
  const [severityOfInjuryOptions, setSeverityOfInjuryOptions] = useState<any[]>(
    [],
  );

  const [appointmentStatusOption, setAppointmentStatusOption] = useState<any[]>(
    [],
  );
  const [clinicOption, setClinicOption] = useState<any[]>([]);
  const [QMEDoctorOptions, setQMEDoctorOptions] = useState<any[]>([]);
  const [qmeCategoryOptions, setQMECategoryOptions] = useState<any[]>([]);
  const [qmeTypeOptions, setQMETypeOptions] = useState<any[]>([]);

  //Record Tab
  const [documentTypeOptions, setDocumentTypeOptions] = useState<any[]>([]);

  const [documentCategoryOptions, setDocumentCategoryOptions] = useState<any[]>(
    [],
  );

  const handleDateRangeChange = (newRange: [Date | null, Date | null]) => {
    const [start, end] = newRange;

    setDateRange([start ?? undefined, end ?? undefined]);
    setRegistrationStartDate(start ? moment(start).format("YYYY-MM-DD") : null);
    setRegistrationEndDate(end ? moment(end).format("YYYY-MM-DD") : null);
  };

  const handleIncidentDateChange = (data: [Date | null, Date | null]) => {
    setincidentdateRange(data);
    const [startDate, endDate] = data;
    setIncidentStartDate(
      startDate ? moment(startDate).format("YYYY-MM-DD") : null,
    );
    setIncidentEndDate(endDate ? moment(endDate).format("YYYY-MM-DD") : null);
  };

  const handleAppointmentDateChange = (data: [Date | null, Date | null]) => {
    setAppointmentdateRange(data);
    const [startDate, endDate] = data;
    setAppointmentStartDate(
      startDate ? moment(startDate).format("YYYY-MM-DD") : null,
    );
    setAppointmentEndDate(
      endDate ? moment(endDate).format("YYYY-MM-DD") : null,
    );
  };

  const handleStartTimeChange = (time: string) => {
    setAppointmentStartTime(time);
  };

  const stakeholderCodes = {
    client: STAKEHOLDER_LIST_CODE.PRACTICE_MANAGEMENT_COMPANY,
    applicant: STAKEHOLDER_LIST_CODE.APPLICANT_ATTORNEY,
    defence: STAKEHOLDER_LIST_CODE.DEFENCE_ATTORNEY,
    insurance: STAKEHOLDER_LIST_CODE.INSURANCE,
    employer: STAKEHOLDER_LIST_CODE.EMPLOYER,
  };

  const fetchPickListData = async () => {
    try {
      const medicalOption = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Conduct_Medical_Exam,
        triggerById: loggedInUserid,
      });

      setMedicalExamOptions(medicalOption);

      const responsePriority = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Case_Priority,
        triggerById: loggedInUserid,
      });
      setPriorityOptions(responsePriority);

      const responseCaseType = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Case_Review_Type,
        triggerById: loggedInUserid,
      });
      setCaseReviewOptions(responseCaseType);

      const responseCaseStages = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Case_Stages,
        triggerById: loggedInUserid,
      });
      setCaseStageOptions(responseCaseStages);

      const responseClient = await fetchCaseStakeholderList(
        stakeholderCodes.client,
        "",
      );
      setclientOptions(responseClient);

      const responseApplicantAttorney = await fetchCaseStakeholderList(
        stakeholderCodes.applicant,
        "",
      );
      setapplicantAttorneyOptions(responseApplicantAttorney);
      const responseDefenceAttorney = await fetchCaseStakeholderList(
        stakeholderCodes.defence,
        "",
      );
      setdefenceAttorneyOptions(responseDefenceAttorney);

      const responseInsurance = await fetchCaseStakeholderList(
        stakeholderCodes.insurance,
        "",
      );
      setinsuranceOptions(responseInsurance);

      const responseEmployer = await fetchCaseStakeholderList(
        stakeholderCodes.employer,
        "",
      );
      setemployerOptions(responseEmployer);

      const appointmentStatus = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Appointment_Status,
        triggerById: loggedInUserid,
      });

      const responseInjuryTypes = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Injury_Type,
        triggerById: loggedInUserid,
      });
      setInjuryTypeOptions(responseInjuryTypes);

      const responseSeverityOfInjury = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.SeverityOf_Injury,
        triggerById: loggedInUserid,
      });
      setSeverityOfInjuryOptions(responseSeverityOfInjury);

      setAppointmentStatusOption(appointmentStatus);

      const clinicName = await AddedQMEDoctorHospitalList();

      setClinicOption(clinicName);

      const doctorName = await AddedQMEDoctorList();

      setQMEDoctorOptions(doctorName);

      const qmeCategory = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Appointment_Category,
        triggerById: loggedInUserid,
      });

      setQMECategoryOptions(qmeCategory);

      const qmeType = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Appointment_Type,
        triggerById: loggedInUserid,
      });

      setQMETypeOptions(qmeType);

      const documentType = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Document_Category,
        triggerById: loggedInUserid,
      });

      setDocumentTypeOptions(documentType);

      const documentCategory = await fetchDocumentCategory();

      setDocumentCategoryOptions(documentCategory);
    } catch (error) {
      console.error("Error fetching picklist data:", error);
    }
  };

  useEffect(() => {
    fetchPickListData();
  }, [isOpen]);

  useEffect(() => {
    console.log(initialFilters);

    if (initialFilters) {
      setCaseId(initialFilters.caseId || "");
      setSelectedPriority(
        initialFilters.priorityIds
          ? initialFilters.priorityIds.split(",").map(Number)
          : [],
      );

      setSelectedCaseReview(
        initialFilters.caseReviewTypeIds
          ? initialFilters.caseReviewTypeIds.split(",").map(Number)
          : [],
      );
      setClaimNo(initialFilters.claimNumber || "");
      setWcabNo(initialFilters.wcabNumber || "");
      setPanelNo(initialFilters.panelNumber || "");
      setFileNo(initialFilters.fileNumber || "");
      setCaseName(initialFilters.caseName || "");
      setAdjNo(initialFilters.adjNumber || "");
      setSelectedCaseStage(
        initialFilters.caseStageIds
          ? initialFilters.caseStageIds.split(",").map(Number)
          : [],
      );
      setselectedClient(
        initialFilters.clientIds
          ? initialFilters.clientIds.split(",").map(Number)
          : [],
      );
      setSelectedApplicantAttrorney(
        initialFilters.applicantAttorneyIds
          ? initialFilters.applicantAttorneyIds.split(",").map(Number)
          : [],
      );
      setSelectedDefenceAttorney(
        initialFilters.defenseAttorneyIds
          ? initialFilters.defenseAttorneyIds.split(",").map(Number)
          : [],
      );
      setSelectedInsurance(
        initialFilters.insuranceIds
          ? initialFilters.insuranceIds.split(",").map(Number)
          : [],
      );
      setName(initialFilters.subjectName || "");
      setSsnNo(initialFilters.ssn || "");
      setSelectedInjuryType(
        initialFilters.injuryTypeIds
          ? initialFilters.injuryTypeIds.split(",").map(Number)
          : [],
      );
      setSelectedSeverityOfInjury(
        initialFilters.severityOfInjuryIds
          ? initialFilters.severityOfInjuryIds.split(",").map(Number)
          : [],
      );
      setselectedEmployer(
        initialFilters.employerStakeholderIds
          ? initialFilters.employerStakeholderIds.split(",").map(Number)
          : [],
      );
      setAppointmentNumber(initialFilters.appointmentConfirmationNo || "");
      setSelectedAppointmentStatus(
        initialFilters.appointmentStatusIds
          ? initialFilters.appointmentStatusIds.split(",").map(Number)
          : [],
      );
      setSelectedClinic(
        initialFilters.medicareIds
          ? initialFilters.medicareIds.split(",").map(Number)
          : [],
      );
      setSelectedQME(
        initialFilters.qMedDoctorIds
          ? initialFilters.qMedDoctorIds.split(",").map(Number)
          : [],
      );
      setSelectedQMECategory(
        initialFilters.appointmentCategoryIds
          ? initialFilters.appointmentCategoryIds.split(",").map(Number)
          : [],
      );
      setSelectedQMEType(
        initialFilters.appointmentTypeIds
          ? initialFilters.appointmentTypeIds.split(",").map(Number)
          : [],
      );
      setSelectedDocumentTypeIds(
        initialFilters.documentTypeIds
          ? initialFilters.documentTypeIds.split(",").map(Number)
          : [],
      );
      setSelectedDocumentCategoryIds(
        initialFilters.documentCategoryText
          ? initialFilters.documentCategoryText.split(",").map(Number)
          : [],
      );
      setFileName(initialFilters.fileName || "");
      setAddlFileDesc(initialFilters.addlFileDesc || "");
      setUploadedByName(initialFilters.uploadedByName || "");
      setAdditionalComments(initialFilters.additionalComments || "");
      if (
        initialFilters?.dateOfRegistrationFrom &&
        initialFilters?.dateOfRegistrationTo
      ) {
        const start = new Date(initialFilters.dateOfRegistrationFrom);
        const end = new Date(initialFilters.dateOfRegistrationTo);

        setDateRange([start, end]);
        setRegistrationStartDate(initialFilters.dateOfRegistrationFrom);
        setRegistrationEndDate(initialFilters.dateOfRegistrationTo);
      }
      if (
        initialFilters?.dateOfIncidentFrom &&
        initialFilters?.dateOfIncidentTo
      ) {
        const start = new Date(initialFilters.dateOfIncidentFrom);
        const end = new Date(initialFilters.dateOfIncidentTo);

        setincidentdateRange([start, end]);
        setIncidentStartDate(initialFilters.dateOfIncidentFrom);
        setIncidentStartDate(initialFilters.dateOfIncidentTo);
      }
      if (
        initialFilters?.dateOfAppointmentStart &&
        initialFilters?.dateOfAppointmentEnd
      ) {
        const start = new Date(initialFilters.dateOfAppointmentStart);
        const end = new Date(initialFilters.dateOfAppointmentEnd);

        setAppointmentdateRange([start, end]);
        setAppointmentStartDate(initialFilters.dateOfAppointmentStart);
        setAppointmentStartDate(initialFilters.dateOfAppointmentEnd);
      }
      if (initialFilters?.startTime) {
        setAppointmentStartTime(
          initialFilters.startTime
            ? new Date(initialFilters.startTime).toTimeString().slice(0, 5)
            : undefined,
        );
      }
      setIsInterpreterReq(
        initialFilters?.isInterpreterRequired === 1
          ? true
          : initialFilters?.isInterpreterRequired === 0
            ? false
            : undefined,
      );
      setIsMedicalExam(initialFilters.medicalExamTypeId || null);
      setUploadDateTime(initialFilters.uploadDateTime || null);
    }
  }, [initialFilters]);
  console.log(dateOfRegistrationFrom, dateOfRegistrationTo, "dates");

  const handleSearch = () => {
    const payload = {
      caseId: caseId,
      claimNumber: claimNumber,
      wcabNumber: wcabNumber,
      panelNumber: panelNumber,
      fileNumber: fileNumber,
      caseName: caseName,
      caseNumber: caseNumber,
      adjNumber: adjNumber,
      subjectName: subjectName,
      ssn: ssn,
      employerStakeholderIds: selectedEmployer.join(","),
      priorityIds: selectedPriority.join(","),
      caseReviewTypeIds: selectedCaseReview.join(","),
      caseStageIds: selectedCaseStage.join(","),
      injuryTypeIds: selectedInjuryType.join(","),
      severityOfInjuryIds: selectedSeverityOfInjury.join(","),
      dateOfRegistrationFrom: dateOfRegistrationFrom,
      dateOfRegistrationTo: dateOfRegistrationTo,
      dateOfIncidentFrom: dateOfIncidentFrom,
      dateOfIncidentTo: dateOfIncidentTo,
      clientIds: selectedClient.join(","),
      applicantAttorneyIds: selectedApplicantAttrorney.join(","),
      defenseAttorneyIds: selectedDefenceAttorney.join(","),
      insuranceIds: selectedInsurance.join(","),
      vendorIds: null,
      appointmentConfirmationNo: appointmentConfirmationNo,
      dateOfAppointmentStart: dateOfAppointmentStart,
      dateOfAppointmentEnd: dateOfAppointmentEnd,
      startTime: startTime
        ? formatDateTime(StartdateOfAppointment, startTime)
        : null,
      appointmentStatusIds: selectedAppointmentStatus.join(","),
      medicareIds: selectedClinic.join(","),
      qMedDoctorIds: selectedQME.join(","),
      appointmentCategoryIds: selectedQMECategory.join(","),
      appointmentTypeIds: selectedQMEType.join(","),
      isInterpreterRequired:
        isInterpreterReq === true ? 1 : isInterpreterReq === false ? 0 : null,
      medicalExamTypeId: ismedicalExam,
      documentTypeIds: selectedDocumentTypeIds.join(","),
      documentCategoryText: selectedDocumentCategoryIds.join(","),
      fileName: fileName,
      addlFileDesc: addlFileDesc,
      uploadedByName: uploadedByName,
      uploadDateTime: uploadDateTime ? formatDateTime(uploadDateTime) : null,
      additionalComments: additionalComments,
    };

    onSearch(payload); // <-- Send to parent
  };

  const handleReset = () => {
    setCaseId("");
    setRegistrationStartDate(null);
    setRegistrationEndDate(null);
    setDateRange([undefined, undefined]);
    setincidentdateRange([null, null]);
    setSelectedPriority([]);
    setSelectedCaseReview([]);
    setClaimNo("");
    setWcabNo("");
    setPanelNo("");
    setFileNo("");
    setCaseName("");
    setCaseNumber("");
    setAdjNo("");
    setSelectedCaseStage([]);
    setName("");
    setSsnNo("");
    setSelectedInjuryType([]);
    setSelectedSeverityOfInjury([]);
    setselectedEmployer([]);
    setIncidentStartDate(null);
    setIncidentEndDate(null);
    setSelectedApplicantAttrorney([]);
    setSelectedDefenceAttorney([]);
    setselectedClient([]);
    setSelectedInsurance([]);
    setAppointmentNumber("");
    setAppointmentdateRange([null, null]);
    setAppointmentStartDate(null);
    setAppointmentStartTime("");
    setSelectedAppointmentStatus([]);
    setSelectedAppointmentStatus([]);
    setSelectedClinic([]);
    setSelectedQME([]);
    setSelectedQME([]);
    setSelectedQMEType([]);
    setIsInterpreterReq(undefined);
    setIsMedicalExam(null);
    setSelectedDocumentTypeIds([]);
    setSelectedDocumentCategoryIds([]);
    setSelectedDocumentCategoryIds([]);
    setFileName("");
    setUploadedByName("");
    setAddlFileDesc("");
    setAdditionalComments("");
    setUploadDateTime(null);

    if (onReset) {
      onReset();
    }

    // 🔐 Close popup
    if (onClose) {
      onClose();
    }
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
        />
        <Dialog.Content
          className="dialogbox"
          style={{
            position: "fixed",
            top: "50px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "white",

            borderRadius: "8px",
            minWidth: "1150px",
            maxWidth: "1300px",
            zIndex: "1001",
          }}
        >
          <Dialog.Title>Advanced Search</Dialog.Title>
          <button
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "transparent",
              border: "0px",
              fontSize: "22px",
              cursor: "pointer",
              color: "#0092D5",
            }}
            onFocus={(e) =>
              (e.currentTarget.style.outline = "0px solid #0092D5")
            }
            onBlur={(e) => (e.currentTarget.style.outline = "none")}
            onClick={onClose}
          >
            &times;
          </button>
          <Container>
            <Row>
              <Col>
                <Tabs
                  activeKey={activeTab}
                  onSelect={(key) => setActiveTab(key as string)}
                  className="mb-3 px-3 po-tab tabsection nav nav-tabs"
                >
                  {TABS.map((tab) => (
                    <Tab eventKey={tab.label} title={tab.label} key={tab.label}>
                      {tab.label === "Case info" && (
                        <Form>
                          <Container>
                            <Row className="mt-3">
                              <Col sm={3}>
                                <TextInput
                                  label="Case ID"
                                  name="caseId"
                                  value={caseId}
                                  maxLength={50}
                                  onChange={(e) =>
                                    setCaseId(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setCaseId(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <div className="date-picker-container customDrodownControlDAtepicker">
                                  <DateRangePicker
                                    label="Date Of Registration"
                                    startDate={dateRange[0]}
                                    endDate={dateRange[1]}
                                    onChange={handleDateRangeChange}
                                  />
                                </div>
                              </Col>
                              <Col sm={3} className="selection_dropdown ">
                                <SearchableMultiSelectDropdown
                                  label="Priority"
                                  name="priority"
                                  options={priorityOptions} // Format: { value: string, label: string }
                                  values={selectedPriority}
                                  onChange={(e, name, values) =>
                                    setSelectedPriority(values)
                                  }
                                />
                              </Col>
                              <Col sm={3} className="selection_dropdown">
                                <SearchableMultiSelectDropdown
                                  label="Case(Review) Type"
                                  name="Select Case Review"
                                  options={caseReviewOptions}
                                  values={selectedCaseReview}
                                  onChange={(e, name, values) =>
                                    setSelectedCaseReview(values)
                                  }
                                />
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col sm={3}>
                                <TextInput
                                  label="Claim No."
                                  name="claimNo"
                                  value={claimNumber}
                                  maxLength={50}
                                  onChange={(e) =>
                                    setClaimNo(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setClaimNo(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <TextInput
                                  label="WCAB No."
                                  name="wcabNo"
                                  value={wcabNumber}
                                  maxLength={100}
                                  onChange={(e) =>
                                    setWcabNo(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setWcabNo(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <TextInput
                                  label="Panel No."
                                  name="panelNo"
                                  value={panelNumber}
                                  maxLength={50}
                                  onChange={(e) =>
                                    setPanelNo(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setPanelNo(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <TextInput
                                  label="File No."
                                  name="fileNo"
                                  value={fileNumber}
                                  maxLength={50}
                                  onChange={(e) =>
                                    setFileNo(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setFileNo(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col sm={3}>
                                <TextInput
                                  label="Case Name"
                                  name="caseName"
                                  value={caseName}
                                  maxLength={200}
                                  onChange={(e) =>
                                    setCaseName(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setCaseName(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <TextInput
                                  label="Case Number"
                                  name="caseNumber"
                                  value={caseNumber}
                                  maxLength={50}
                                  onChange={(e) =>
                                    setCaseNumber(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setCaseNumber(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <TextInput
                                  label="ADJ No."
                                  name="adjNo"
                                  value={adjNumber}
                                  maxLength={50}
                                  onChange={(e) =>
                                    setAdjNo(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setAdjNo(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col
                                sm={3}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Case Stage"
                                  name="Select Case Stage"
                                  options={caseStageOptions}
                                  values={selectedCaseStage}
                                  onChange={(e, name, values) =>
                                    setSelectedCaseStage(values)
                                  }
                                />
                              </Col>
                            </Row>
                          </Container>
                        </Form>
                      )}
                      {tab.label === "Parties" && (
                        <Form>
                          <Container>
                            <Row className="mt-3">
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Client"
                                  name="Select Client"
                                  options={clientOptions}
                                  values={selectedClient}
                                  onChange={(e, name, values) =>
                                    setselectedClient(values)
                                  }
                                />
                              </Col>
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Applicant Attorney"
                                  name="Select Applicant Attorney"
                                  options={applicantAttorneyOptions}
                                  values={selectedApplicantAttrorney}
                                  onChange={(e, name, values) =>
                                    setSelectedApplicantAttrorney(values)
                                  }
                                />
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Defense Attorney"
                                  name="Select Defence Attorney"
                                  options={defenceAttorneyOptions}
                                  values={selectedDefenceAttorney}
                                  onChange={(e, name, values) =>
                                    setSelectedDefenceAttorney(values)
                                  }
                                />
                              </Col>
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Insurance(Claims)"
                                  name="Select Insurance(Claims)"
                                  options={insuranceOptions}
                                  values={selectedInsurance}
                                  onChange={(e, name, values) =>
                                    setSelectedInsurance(values)
                                  }
                                />
                              </Col>
                            </Row>
                          </Container>
                        </Form>
                      )}
                      {tab.label === "Patient" && (
                        <Form>
                          <Container>
                            <Row className="mt-3">
                              <Col sm={3}>
                                <TextInput
                                  label="Name"
                                  name="name"
                                  value={subjectName}
                                  maxLength={100}
                                  onChange={(e) => setName(e.target.value)} // Trims spaces while typing
                                  onBlur={(e) => setName(e.target.value)} // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <TextInput
                                  label="SSN No."
                                  name="ssnNo"
                                  value={
                                    isSSNFocused
                                      ? ssn
                                      : ssn.length === 11
                                        ? `XXX-XX-${ssn.slice(-4)}`
                                        : ssn
                                  }
                                  maxLength={11}
                                  onChange={(e) =>
                                    setSsnNo(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setSsnNo(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col
                                sm={3}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Injury Type"
                                  name="Select Injury"
                                  options={injuryTypeOptions}
                                  values={selectedInjuryType}
                                  onChange={(e, name, values) =>
                                    setSelectedInjuryType(values)
                                  }
                                />
                              </Col>
                              <Col sm={3}>
                                <div className="date-picker-container customDrodownControlDAtepicker">
                                  <DateRangePicker
                                    startDate={
                                      incidentdateRange[0] ?? undefined
                                    }
                                    label="Date Of Incident"
                                    endDate={incidentdateRange[1] ?? undefined}
                                    onChange={handleIncidentDateChange}
                                    minDate={oneYearAgo}
                                    maxDate={today}
                                  />
                                </div>
                              </Col>
                              <Col
                                sm={3}
                                className="selection_dropdown adj_label_lt mt-4"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Severity Of Injury"
                                  name="Select Severity"
                                  options={severityOfInjuryOptions}
                                  values={selectedSeverityOfInjury}
                                  onChange={(e, name, values) =>
                                    setSelectedSeverityOfInjury(values)
                                  }
                                />
                              </Col>
                              <Col
                                sm={3}
                                className="selection_dropdown adj_label_lt mt-4"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Employer"
                                  name="Employer"
                                  options={employerOptions}
                                  values={selectedEmployer}
                                  onChange={(e, name, values) =>
                                    setselectedEmployer(values)
                                  }
                                />
                              </Col>
                            </Row>
                          </Container>
                        </Form>
                      )}
                      {tab.label === "QME Schedule" && (
                        <Form>
                          <Container>
                            <Row className="mt-3">
                              <Col sm={3}>
                                <TextInput
                                  label="Appointment No"
                                  name="appointment"
                                  value={appointmentConfirmationNo}
                                  onChange={(e) =>
                                    setAppointmentNumber(e.target.value.trim())
                                  }
                                />
                              </Col>
                              <Col sm={3}>
                                <div className="date-picker-container customDrodownControlDAtepicker">
                                  <DateRangePicker
                                    label="Date Of Appointment"
                                    startDate={
                                      appintmentdateRange[0] ?? undefined
                                    }
                                    endDate={
                                      appintmentdateRange[1] ?? undefined
                                    }
                                    onChange={handleAppointmentDateChange}
                                  />
                                </div>
                              </Col>
                              <Col sm={3}>
                                <TimePicker
                                  selectedTime={startTime}
                                  onChange={handleStartTimeChange}
                                  label="Appointment Time"
                                />
                              </Col>
                              <Col
                                sm={3}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Status"
                                  name="Status"
                                  options={appointmentStatusOption}
                                  values={selectedAppointmentStatus}
                                  onChange={(e, name, values) =>
                                    setSelectedAppointmentStatus(values)
                                  }
                                />
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Location"
                                  name="clinic"
                                  options={clinicOption}
                                  values={selectedClinic}
                                  onChange={(e, name, values) =>
                                    setSelectedClinic(values)
                                  }
                                />
                              </Col>
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="QME Doctor"
                                  name="Status"
                                  options={QMEDoctorOptions}
                                  values={selectedQME}
                                  onChange={(e, name, values) =>
                                    setSelectedQME(values)
                                  }
                                />
                              </Col>
                            </Row>

                            <Row className="mt-3">
                              <Col
                                sm={3}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Category"
                                  name="Category"
                                  options={qmeCategoryOptions}
                                  values={selectedQMECategory}
                                  onChange={(e, name, values) =>
                                    setSelectedQMECategory(values)
                                  }
                                />
                              </Col>
                              <Col
                                sm={3}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Type"
                                  name="Status"
                                  options={qmeTypeOptions}
                                  values={selectedQMEType}
                                  onChange={(e, name, values) =>
                                    setSelectedQMEType(values)
                                  }
                                />
                              </Col>
                              <Col sm={3} className="d-flex align-items-center">
                                <div className="d-flex align-items-center gap-2">
                                  <label
                                    className="me-2"
                                    style={{ fontWeight: "500" }}
                                  >
                                    Interpreter Required{" "}
                                  </label>

                                  <label className="d-flex align-items-center">
                                    <input
                                      type="radio"
                                      name="interpreterRequired"
                                      checked={isInterpreterReq === true}
                                      onChange={() => setIsInterpreterReq(true)}
                                      className="me-1"
                                    />
                                    Yes
                                  </label>

                                  <label className="d-flex align-items-center">
                                    <input
                                      type="radio"
                                      name="interpreterRequired"
                                      checked={isInterpreterReq === false}
                                      onChange={() => {
                                        setIsInterpreterReq(false);
                                      }}
                                      className="me-1"
                                    />
                                    No
                                  </label>
                                </div>
                              </Col>
                              <Col
                                sm={3}
                                className="d-flex align-items-center px-0"
                              >
                                <div className="d-flex align-items-center gap-1">
                                  <label
                                    className="me-1"
                                    style={{ fontWeight: "500" }}
                                  >
                                    Medical Exam{" "}
                                  </label>
                                  {medicalExamOptions?.map((option) => (
                                    <label key={option.value}>
                                      <input
                                        type="radio"
                                        name="ismedicalExam"
                                        value={option.value}
                                        checked={ismedicalExam === option.value}
                                        onChange={() =>
                                          setIsMedicalExam(option.value)
                                        }
                                      />
                                      <span className="ms-1">
                                        {option.label}
                                      </span>
                                    </label>
                                  ))}
                                </div>
                              </Col>
                            </Row>
                          </Container>
                        </Form>
                      )}
                      {tab.label === "Records" && (
                        <Form>
                          <Container>
                            <Row className="mt-3">
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Document Type"
                                  name="Document Type"
                                  options={documentTypeOptions}
                                  values={selectedDocumentTypeIds}
                                  onChange={(e, name, values) =>
                                    setSelectedDocumentTypeIds(values)
                                  }
                                />
                              </Col>
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Category"
                                  name="Category"
                                  options={documentCategoryOptions}
                                  values={selectedDocumentCategoryIds}
                                  onChange={(e, name, values) =>
                                    setSelectedDocumentCategoryIds(values)
                                  }
                                />
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col sm={6}>
                                <TextInput
                                  label="File Name"
                                  name="filename"
                                  value={fileName}
                                  maxLength={100}
                                  onChange={(e) => setFileName(e.target.value)} // Trims spaces while typing
                                  onBlur={(e) => setFileName(e.target.value)} // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={6}>
                                <TextInput
                                  label="File Description"
                                  name="filedesc"
                                  value={addlFileDesc}
                                  maxLength={100}
                                  onChange={(e) =>
                                    setAddlFileDesc(e.target.value)
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setAddlFileDesc(e.target.value)
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col sm={3}>
                                <TextInput
                                  label="Uploaded By"
                                  name="uploadedBy"
                                  value={uploadedByName}
                                  maxLength={100}
                                  onChange={(e) =>
                                    setUploadedByName(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setUploadedByName(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <FloatingLabelDatepicker
                                  label="Uploaded On"
                                  name="uploaded"
                                  value={uploadDateTime}
                                  onChange={(date: Date | null) => {
                                    setUploadDateTime(date);
                                  }}
                                  dateFormat="MM/dd/yyyy"
                                />
                              </Col>
                              <Col sm={6}>
                                <TextInput
                                  label="Additional Comments"
                                  name="additionalComments"
                                  value={additionalComments}
                                  maxLength={100}
                                  onChange={(e) =>
                                    setAdditionalComments(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setAdditionalComments(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                            </Row>
                          </Container>
                        </Form>
                      )}
                    </Tab>
                  ))}
                </Tabs>
              </Col>
            </Row>
          </Container>
          <div className="d-flex justify-content-end mt-3 px-2 pb-3">
            <Button
              variant="outline-info"
              className="d-flex align-items-center"
              onClick={handleReset}
            >
              <span className="material-icons mx-1">autorenew</span> Reset
            </Button>
            <Button
              variant="primary"
              className="btn btn-primary d-flex align-items-center mx-2"
              onClick={handleSearch}
            >
              <span className="material-icons">search</span>Search
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default AppointmentAdvanceSearch;
